import type { Bounds, Container } from 'pixi.js';

export interface RecyclablePiece {
  activate(): void;
  deactivate(): void;
  destroy(): void;
}

interface RecyclablePieceSlot {
  y: number;
  margin: number;
  active: boolean;
  piece: RecyclablePiece;
}

export interface OneWaySlot {
  y: number;
  margin?: number;
  toDelete?: boolean;
  initializer: () => void;
}

export class RecyclableCullingView {
  private readonly slots: RecyclablePieceSlot[] = [];

  private oneWaySlot: OneWaySlot[] = [];

  constructor(private readonly rootContainer: Container) {
    rootContainer.on('destroyed', () => {
      this.slots.forEach((slot) => {
        slot.piece.destroy();
      });
    });
  }

  public addPiece(piece: RecyclablePiece, y: number, margin = 500): void {
    this.slots.push({
      piece,
      y,
      margin,
      active: false,
    });
  }

  public addOneWayPiece(oneWayInitializer: OneWaySlot): void {
    this.oneWaySlot.push(oneWayInitializer);
  }

  public update(globalBounds: Bounds): void {
    const yMin = this.rootContainer.toLocal({ x: 0, y: globalBounds.top }).y;
    const yMax = this.rootContainer.toLocal({ x: 0, y: globalBounds.bottom }).y;

    this.slots.forEach((slot) => {
      const { active, y, margin, piece } = slot;

      const inView = y > yMin - margin && y < yMax + margin;

      if (inView && !active) {
        piece.activate();
        slot.active = true;
      } else if (!inView && active) {
        piece.deactivate();
        slot.active = false;
      }
    });

    let initialized = false;
    this.oneWaySlot.forEach((oneWaySlot) => {
      const { y, margin = 500, initializer } = oneWaySlot;
      const inView = y > yMin - margin && y < yMax + margin;
      if (inView) {
        initializer();
        oneWaySlot.toDelete = true;
        initialized = true;
      }
    });

    if (initialized) {
      this.oneWaySlot = this.oneWaySlot.filter((slot) => !slot.toDelete);
    }
  }
}
